import styled from '@emotion/styled';
import { Box, BoxProps, Text, TextProps } from '@opendoor/bricks-next';

import { EntryComponent } from '../../cms/entries/entries';
import { IComponentFooterBox } from '../../declarations/contentful';
import { SellerFlowAddressInput } from '../shared/SellerFlowAddressInput';
import { EmbeddedEntryWrapper } from './EmbeddedEntryWrapper';

const DownloadButton = styled.a`
  @media (max-width: 767px) {
    display: inline-block;
    margin: 0 5px;
  }
`;

const UL = styled.ul<{ buyer: boolean }>`
  margin: 0 0 40px;
  padding: 0;
  list-style: none;

  & li {
    position: relative;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 10px;
    font-size: 17px;
    font-weight: 500;
    padding-left: 30px;
  }

  & li:before {
    content: ''; //✓
    position: absolute;
    filter: ${(props) => (props.buyer ? 'brightness(0)' : undefined)};
    left: 0;
    top: 7px;
    width: 18px;
    height: 14px;
    background-size: cover;
    background-image: url('https://imgdrop.imgix.net/40cb0b0734474487aab7826d892392a2.png');
  }
`;

const data: {
  [key: string]: {
    background: BoxProps['backgroundColor'];
    color: TextProps['color'];
    image: string;
  };
} = {
  seller: {
    background: '$backgroundAccentBrand',
    color: '$contentInversePrimary',
    image: 'https://imgdrop.imgix.net/88aa4836e2dd4ed0bbabfe18cbbaff0f.png',
  },
  buyer: {
    background: '$backgroundStateInactiveAccentError',
    color: '$contentPrimary',
    image: 'https://imgdrop.imgix.net/cf1dd00bb2f8481481728c5ffb902d64.png',
  },
  agent: {
    background: '$backgroundInverseAccentBrand',
    color: '$contentInversePrimary',
    image: 'https://imgdrop.imgix.net/88aa4836e2dd4ed0bbabfe18cbbaff0f.png',
  },
};

const renderFooterBox = (entry: IComponentFooterBox) => {
  const { fields } = entry;

  return (
    <EmbeddedEntryWrapper>
      <Box backgroundColor={data[fields.variant].background} borderRadius="$10x" paddingTop="$10x">
        <Box
          flexWrap={'wrap'}
          marginHorizontal={'auto'}
          alignItems="center"
          justifyContent="space-around"
          maxWidth="90%"
          $largerThanSM={{
            maxWidth: 720,
            paddingLeft: '$12x',
          }}
          $largerThanMD={{
            maxWidth: 960,
            paddingLeft: '$16x',
          }}
          flexDirection="row"
        >
          <Box width="100%" $largerThanSM={{ width: '47.5%' }} paddingVertical="$20x">
            <Text
              tag="h2"
              typography="$headerMedium"
              lineHeight="$headerLarge"
              marginBottom="$10x"
              color={data[fields.variant].color as any}
            >
              {fields.title}
            </Text>
            <Text
              tag="p"
              typography="$bodyMedium"
              mb="$4x"
              color={data[fields.variant].color as any}
            >
              {fields.content && (
                <UL buyer={(fields.variant as string) === 'buyer'}>
                  {fields.content.map((e: string, index: number) => (
                    <li key={index + '_' + e}>{e}</li>
                  ))}
                </UL>
              )}
            </Text>
            {(fields.variant as string) !== 'buyer' ? (
              <SellerFlowAddressInput
                analyticsName="cosmos-footerbox-address-input"
                channel="DEFAULT"
                inputLocation="footerbox-cta"
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus={false}
                placeholderText={fields.placeholder}
                showCta
                ctaProps={{
                  actionText: fields.buttonText,
                  'aria-label': '',
                }}
                product="SELL_DIRECT"
              />
            ) : (
              // z-index to make buttons appear above phone
              <Box
                flexDirection="row"
                $largerThanSM={{ gap: '$6x' }}
                position="relative"
                zIndex={10}
              >
                <DownloadButton href="https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en">
                  <img
                    src="https://imgdrop.imgix.net/3a52f003f27742f3b4384a3168352335.png"
                    alt="Play store button"
                    height={45}
                  />
                </DownloadButton>
                <DownloadButton href="https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8">
                  <img
                    src="https://imgdrop.imgix.net/03f8e282af254a80ac28358e640319ab.svg"
                    alt="App store button"
                    height={45}
                  />
                </DownloadButton>
              </Box>
            )}
          </Box>
          <Box
            width="100%"
            $largerThanSM={{ width: '47.5%' }}
            alignSelf={'flex-end'}
            flexDirection="row"
          >
            <img style={{ maxWidth: '100%' }} src={data[fields.variant].image} alt="" />
          </Box>
        </Box>
      </Box>
    </EmbeddedEntryWrapper>
  );
};

const FooterBox: EntryComponent<IComponentFooterBox> = {
  render: renderFooterBox,
};

export default FooterBox;
